import {NullAsDefault, renderIf} from "../../views/Shared";
import _ from "lodash";
import React from "react";
import useTranslate from "../../modules/local/useTranslate";
import {BsXLg} from "react-icons/bs";

export const FilterStatusBar = ({filteredParams = [], onClear = NullAsDefault, onRemove = NullAsDefault}) => {
    const t = useTranslate();

    if (filteredParams.filter(e => !!e.displayValue).length === 0) return null;

    return (
        <div className="text-left space-x-2 space-y-1 mb-2 inline-block">
            <span className="font-medium text-xs text-color-400 italic leading-tight whitespace-no-wrap">
                {`${t('content is filtered by')} : `}
            </span>
            {filteredParams.filter(e => !!e.displayValue).map(fItem => (
                <span
                    style={{
                        height: 24,
                        fontSize: 12,
                        padding: '3px 8px',
                        border: '1px solid #ddd'
                    }}
                    key={fItem.key}
                    className="w-fit space-x-2 rounded-full cursor-pointer">
                    <span className="font-medium text-color-200 italic leading-tight">
                        {fItem.displayValue}
                    </span>
                    <BsXLg
                        size={8}
                        onClick={() => {onRemove(fItem.key)}}
                        className="text-color-200 hover:text-primary-500 cursor-pointer"
                    />
                </span>
            ))}
            {renderIf(
                !_.isEmpty(filteredParams),
                <span
                    onClick={() => {onClear()}}
                    className="ml-4 font-medium text-xs text-primary-300 hover:text-primary-500 italic cursor-pointer whitespace-no-wrap">
                    {t('remove filter')}
                </span>
            )}
        </div>
    )
}